export default "__VITE_ASSET__DxGFPiF5__"